import { Auth } from 'aws-amplify';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SignInPage } from '../../components/alliance/sign-in-page';
import { AuthContext } from '../../contexts/auth-context';
import { captureError } from '../../utils/capture-error';
import { consumeSessionExpired } from '../../utils/session-expired';
import { getSignInContent } from './sign-in-content';

/**
 * The Sign In page (layout A, dark). Sign in goes to the Cognito Hosted UI;
 * the button shows a pending state, and a failure to start the redirect is
 * reported and shown on the button instead of silently doing nothing.
 *
 * It calls Auth.federatedSignIn directly rather than utils/authenticate's
 * signIn: RequireAuth has already stored the page the user was trying to
 * reach, and signIn would overwrite that with /sign-in.
 */
export function SignIn() {
  // Context
  const { state } = React.useContext(AuthContext);
  // State
  const [expired] = React.useState(consumeSessionExpired);
  const [content] = React.useState(() => getSignInContent());
  // Hooks
  const navigate = useNavigate();

  React.useEffect(() => {
    if (state.user !== undefined) {
      navigate('/home');
    }
  }, [state.user, navigate]);

  // Forgot Password Link
  const linkForForgot = `https://${process.env.REACT_APP_AWS_DOMAIN}/forgotPassword?client_id=${process.env.REACT_APP_AWS_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_AWS_REDIRECT_SIGN_IN}`;

  const handleSignIn = async () => {
    try {
      await Auth.federatedSignIn();
    } catch (error) {
      captureError({ data: { error } });
      // Rethrow so the page shows the failed state
      throw error;
    }
  };

  return (
    <SignInPage
      onSignIn={handleSignIn}
      forgotPasswordHref={linkForForgot}
      signUpHref="https://thealliancecontracting.com/sign-up/the-alliance"
      notice={expired ? 'expired' : null}
      photo={content.photo}
      quote={content.quote}
    />
  );
}
